var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Button from "@irati/ui/src/Button";
import Flex from "@irati/ui/src/Flex";
import { Para } from "@irati/ui/src/Labels";
import { SIDEBAR_INDENT } from "../SideBar/styled";
import { Content } from "../StepContent/styled";
export var InviteContent = styled(Content)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.white;
});
export var InviteAdminWrapper = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 12px 0;\n  padding-left: ", ";\n  cursor: pointer;\n  ", "\n  &:hover {\n    text-decoration: underline;\n  }\n"], ["\n  padding: 12px 0;\n  padding-left: ", ";\n  cursor: pointer;\n  ", "\n  &:hover {\n    text-decoration: underline;\n  }\n"])), SIDEBAR_INDENT, function (_a) {
    var theme = _a.theme, active = _a.active;
    return active && "background-color: " + theme.colors.greys.light + ";";
});
export var SpacedPara = styled(Para)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-left: 15px;\n"], ["\n  padding-left: 15px;\n"])));
export var Img = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 181px;\n  margin-bottom: 30px;\n"], ["\n  width: 181px;\n  margin-bottom: 30px;\n"])));
export var MaxWContent = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  max-width: ", ";\n  ", "\n"], ["\n  max-width: ", ";\n  ", "\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth;
}, function (_a) {
    var margin = _a.margin;
    return "margin: " + margin + ";";
});
export var MarginBottom = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-bottom: 25px;\n"], ["\n  margin-bottom: 25px;\n"])));
export var MarginButton = styled(Button)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-left: 15px;\n"], ["\n  margin-left: 15px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
